import React, { useState } from "react";

import "./mobileForgotPassword.css";

import Logo from "../../assets/img/logo-og.png";
import Logo2 from "../../assets/img/media-one-logo.png";
import Logo3 from "../../assets/img/gopu-nandilath-G-mart-white.png";
import ForgotPassword from "./components/ForgotPassword";
import EnterOtp from "./components/EnterOtp";
import ChangePassword from "./components/ChangePassword";

const MobileForgotPassword = () => {
  const [forgotStep, setForgotStep] = useState(1);

  function ForgotSteps() {
    switch (forgotStep) {
      case 1:
        return <ForgotPassword ForgotPass={ForgotPass} />;
      case 2:
        return <EnterOtp VerifyOtp={VerifyOtp} />;
      case 3:
        return <ChangePassword />;
      default:
        return null;
    }
  }

  function ForgotPass() {
    setForgotStep(2);
  }

  function VerifyOtp() {
    setForgotStep(3);
  }

  return (
    <div className="mobileForgotPassword">
      <div className="mobileForgotPassword-wrapper">
        <div className="mobileForgotPassword-topSection">
          <div className="mobileForgotPassword-top-wrapper">
            <div className="mobileForgotPassword-logo-wrapper">
              <div className="mobileRegister-logo1">
                <img src={Logo2} alt="" />
              </div>
              <div className="mobileRegister-logo1">
                <img src={Logo} alt="" />
              </div>
              {/* <div className="mobileForgotPassword-logo1">
                <img src={Logo3} alt="" />
              </div> */}
            </div>
            <div className="mobileForgotPassword-heading">
              <h3>FIFA 2026</h3>
              <h3>PREDICTION CONTEST</h3>
            </div>
          </div>
        </div>
        <div className="mobileForgotPassword-bottomSection">
          <div className="mobileForgotPassword-bottom-wrapper">
            {ForgotSteps()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileForgotPassword;
